/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import React from "react";
import Link from "../../Link";
import Image from "../../Image";
import Icon from "../../Icon";
import Conditional from "../../../hocs/Conditional";

const MainMenuOption = ({
  showDefaultSubMenu,
  url,
  submenu,
  label,
  description,
  iconSrc,
  stylingClass,
  mobileSubDropdownOpenclick,
  onMouseEnterSubMenu,
  onMouseLeaveSubMenu,
  isSubOption,
}) => {
  const handleClick = (e) => {
    if (window.location.pathname === url) {
      e.preventDefault();
      window.location.reload();
    }
  };

  return (
    <>
      <Conditional if={!isSubOption}>
        <Link
          to={url}
          className="flex align-flex-start"
          onClick={(e) => {
            handleClick(e);
            mobileSubDropdownOpenclick?.(e);
          }}
          onMouseEnter={onMouseEnterSubMenu}
          onMouseLeave={onMouseLeaveSubMenu}>
          <Image
            src={iconSrc}
            alt={`${label} icon`}
            width="24"
            height="24"
            className={`${stylingClass || ""} !mr-3`}
          />
          <span>
            <h4 className="body-font font-semibold">{label}</h4>
            <p>{description}</p>
          </span>
          <Conditional if={!showDefaultSubMenu && submenu?.length > 0}>
            <Icon
              name="chevronright"
              className="linkchevron"
              width="7px"
              height="11px"
            />
          </Conditional>
        </Link>
      </Conditional>
      <Conditional if={isSubOption}>
        <div className="single-center-link">
          <Link
            to={url}
            className="!p-0 !bg-[#f6f6fe] bg-cover bg-center bg-navbarbg  w-full h-[118px] flex flex-col items-center justify-center rounded-lg"
            onClick={handleClick}>
            <h4 className="body-font font-semibold !m-0 text-center hover:text-cf-primary w-full">
              {label}
            </h4>
            <span className="font-inter text-sm font-normal leading-5 text-center text-cf-primary w-full">
              Learn More »
            </span>
          </Link>
        </div>
      </Conditional>
    </>
  );
};

export default MainMenuOption;
